import axios from "axios";
import Cookies from "js-cookie";
import * as types from "../mutation-types";

// state
export const state = {
  user: null,
  token: Cookies.get("token"),
  remember: null,
};

// mutations
export const mutations = {
  [types.SAVE_TOKEN](state, { token, remember }) {
    state.token = token;
    Cookies.set("token", token, { expires: 7 });
  },

  [types.FETCH_USER_SUCCESS](state, { user }) {
    state.user = user;
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null;
    Cookies.remove("token");
  },

  [types.LOGOUT](state) {
    console.log("logout");
    state.auth = null;
    state.user = null;
    state.token = null;
    localStorage.removeItem("accessToken");
    Cookies.remove("token");
  },

  [types.UPDATE_USER](state, { user }) {
    state.user = user;
  },

  [types.SET_TOKEN_EXPIRATION](state, expires_in) {
    state.accessTokenExpDate =
      expires_in + Math.floor(new Date().getTime() / 1000);
  },
};

// actions
export const actions = {
  saveToken({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload);
  },

  async fetchUser({ commit }) {
    try {
      const headers = [{ Authorization: state.token }];
      const { data } = await axios.get("/api/v1/me", { headers: headers });
      //roda OneSignal.login e gera tags só se o usuario clicou em permitir
      try {
        if (OneSignal?.User?._currentUser?.hasOneSignalId) {
          let externalId = data.data.id;
          let externalIdString = externalId.toString();
          OneSignal.login(externalIdString);

          if (data.data.email) {
            OneSignal.User.addEmail(data.data.email);
          }
          if (data.data.phone) {
            OneSignal.User.addSms(`+55${data.data.phone}`);
          }

          await axios.get("/api/v1/users/profile/oneSignalTags", {
            headers: headers,
          });
        }
      } catch (error) {
        // Handle error from the OneSignal tags request
        console.error("Error fetching OneSignal tags", error);
      }
      commit(types.FETCH_USER_SUCCESS, { user: data.data });
    } catch (e) {
      // Handle errors from the main fetchUser logic
      if (e.response && e.response.status === 404) {
        // Handle 404 error specifically
        window.getApp.sendSnackMessage(
          "Por questões de segurança, sua conta foi suspensa. Por favor, entre em contato com o suporte.",
          "error",
        );
      } else {
        console.error("Error in fetchUser", e);
        commit(types.FETCH_USER_FAILURE);
      }
    }
  },

  async updateUser({ commit }, payload) {
    commit(types.UPDATE_USER, payload);
  },

  async logout({ commit }) {
    try {
      await axios.post("/api/v1/auth/logout");
    } catch (e) {}
    commit(types.LOGOUT);
  },
};

// getters
export const getters = {
  authUser: (state) => state.user,
  authToken: (state) => state.token,
  authCheck: (state) => state.user !== null,
  accessTokenExpDate: (state) => state.accessTokenExpDate,
  isUserInState: (state) => (targetStateId) => {
    return state.user && state.user.state_id === targetStateId;
  },
};
